<template>
  <div class="left-wrap">
    <div class="cert-value-box">
      <el-checkbox-group v-model="certValueList" @change="changeCertValue">
        <el-checkbox
          v-for="(item, index) in listStore.optionList.certValue"
          :key="'value' + index"
          :label="item"
          :value="index"
        />
      </el-checkbox-group>
    </div>
    <template v-if="listStore.certList.length > 0">
      <div class="flex flex-wrap items-center cert-list">
        <CertItem
          v-for="(item, index) in listStore.certList"
          :key="index"
          :item="item"
          :style="{
            marginRight: (index + 1) % 4 === 0 ? '0' : '20px',
          }"
        />
      </div>
      <el-pagination
        layout="prev, pager, next"
        :total="listStore.certTotal"
        next-text="下一页"
        prev-text="上一页"
        :page-size="40"
        :current-page="listStore.searchData.page"
        @current-change="changePage"
      />
    </template>
    <template v-else>
      <div class="flex justify-center items-center no-data-box">
        <img src="@/src/assets/imgs/nodata.png" width="74" alt="no-data" />
        抱歉，没有找到相关内容
      </div>
    </template>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { useRoute } from 'vue-router';
import { useListStore } from '~/src/store/modules/certList';
import CertItem from './CertItem.vue';
const listStore = useListStore();
const route = useRoute();
const certValueList: any = ref([]);

if (route.query.cv) {
  certValueList.value = (route.query.cv as string).split('_');
}

const changePage = (page: number) => {
  listStore.searchData.page = page;
  listStore.getListInfo();
};

const changeCertValue = (value: any) => {
  listStore.searchData.cv = value.join('_');
  listStore.searchData.page = 1;
  listStore.getListInfo();
  // listStore.getOtherData();
  listStore.addQueryParam('cv', listStore.searchData.cv);
};
</script>

<style lang="scss">
.cert-list-page {
  .left-wrap {
    width: 940px;

    .cert-value-box {
      display: flex;
      height: 66px;
      align-items: center;
    }

    .el-checkbox__label {
      font-weight: 400;
    }

    .is-checked {
      + .el-checkbox__label {
        color: #3d64f3;
      }

      .el-checkbox__inner {
        border-color: transparent;
        background-color: #3d64f3;
      }
    }

    .el-pagination {
      justify-content: center;
      padding-top: 16px;
      margin-bottom: 20px;

      button,
      li {
        background-color: transparent;
      }

      button {
        &:hover {
          color: #3d64f3;
        }
      }

      button[disabled] {
        &:hover {
          color: rgb(168, 171, 178);
        }
      }

      li {
        border: 1px solid #e6e6e6;
        border-radius: 4px;
        margin: 0 10px;
        color: #9399a5;
        font-size: 14px;
      }

      .more {
        border: none;
      }

      .is-active {
        border: none;
        background-color: #3d64f3;
        color: #fff;
      }
    }
  }
}
</style>
